import React, {useState} from "react";
import mohammad from "./../assets/images/mohammad.jpg"
import { FaInstagram } from "react-icons/fa6";
import { LuCalendarDays } from "react-icons/lu";
import { CiGlobe } from "react-icons/ci";
import { FiMessageCircle } from "react-icons/fi";
import { RiYoutubeLine } from "react-icons/ri";
import { FaArrowRight } from "react-icons/fa";
import { gradient_primary } from "./../assets/data/colors";

// the biolink page for my instagram
export default function LinkBio (){
    const [openModal, setOpenModal] = useState(true);
    const states = [
        {title: "Cases", info: "120+"},
        {title: "Support", info: "24/7"},
    ];
    const links = [
        {
            title: "Instagram",
            description: "See my latest dental cases & content",
            url: "https://instagram.com/dr.mohammad_sherzad",
            icon: <FaInstagram className="w-6 h-6" style={{color: "#E1306C"}} />,
        },
        {
            title: "Book Appointment",
            description: "Schedule your consultation online",
            url: "#",
            icon: <LuCalendarDays className="w-6 h-6" style={{color: "#4F8EF7"}} />,
        },
        {
            title: "My Website",
            description: "Explore my services and projects",
            url: "https://lighdent.io",
            icon: <CiGlobe className="w-6 h-6" style={{color: "#1D9E75"}} />,
        },
        {
            title: "WhatsApp",
            description: "Contact me directly",
            url: "https://wa.me/9647508078879",
            icon: <FiMessageCircle className="w-6 h-6" style={{color: "#25D366"}} />,
        },
        {
            title: "YouTube",
            description: "Watch tutorials and educational videos",
            url: "https://www.youtube.com/channel/UCmxgLQBzODENCiQWNj_bpdQ",
            icon: <RiYoutubeLine className="w-6 h-6" style={{color: "#FF0000"}} />,
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-100 via-white to-slate-200 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 text-slate-900 dark:text-white flex items-center justify-center px-4 py-10 transition-colors duration-300">
            <div className="w-full max-w-xl">
                <div className="bg-white/80 dark:bg-white/5 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-[32px] shadow-2xl overflow-hidden transition-colors duration-300">
                    <div className="h-40 relative" style={{background: gradient_primary}}>
                        <div className="absolute inset-0 bg-black/10"></div>
                    </div>

                    <div className="px-8 pb-8 relative">
                        <div className="flex justify-center -mt-16 mb-4">
                            <img src={mohammad} alt="Dr. Mohammad Sherzad Abdulaziz" className="w-32 h-32 rounded-full border-2 border-white dark:border-slate-900 object-cover shadow-2xl" />
                        </div>

                        <div className="text-center space-y-3">
                            <h1 className="text-3xl font-bold tracking-tight">Dr. Mohammad Sherzad</h1>
                            <p className="text-slate-600 dark:text-slate-300 text-base leading-relaxed max-w-md mx-auto">Dentist • Implantology Enthusiast • Digital Dentistry • Developer • Programmer • UI & UX Designer</p>
                            <div className="flex items-center justify-center gap-3 flex-wrap pt-2">
                                <span className="px-4 py-1.5 rounded-full bg-primary border border-blue-400/20 text-sm text-white">Kurdistan</span>
                                <span className="px-4 py-1.5 rounded-full bg-emerald-500/20 border border-emerald-400/20 text-sm text-emerald-200">Available for consultations</span>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 mt-8">
                            {states.map(state => (
                                <div key={state.title} className="bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-2xl p-4 text-center transition-colors duration-300">
                                    <h2 className="text-2xl font-bold">{state.info}</h2>
                                    <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">{state.title}</p>
                                </div>
                            ))}
                        </div>

                        <div className="mt-8 space-y-4">
                            {links.map((link, index) => (
                                <a
                                    key={index}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group flex items-center justify-between bg-slate-100/80 dark:bg-white/5 hover:bg-white dark:hover:bg-white/10 border border-slate-200 dark:border-white/10 hover:border-navy transition-all duration-300 rounded-2xl p-5 shadow-sm hover:shadow-lg"
                                >
                                    <div className="flex items-center gap-4">
                                        <div className="w-14 h-14 rounded-2xl bg-white dark:bg-white/10 border border-slate-200 dark:border-white/10 flex items-center justify-center text-2xl group-hover:scale-110 transition-transform duration-300">
                                            {link.icon}
                                        </div>

                                        <div>
                                            <h3 className="font-semibold text-lg">
                                                {link.title}
                                            </h3>
                                            <p className="text-sm text-slate-500 dark:text-slate-400">
                                                {link.description}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="text-slate-500 dark:text-slate-400 text-xl group-hover:translate-x-1 transition-transform duration-300">
                                        <FaArrowRight className="w-5 h-5" />
                                    </div>
                                </a>
                            ))}

                            {openModal && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
        <div className="w-full max-w-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-white/10 rounded-3xl p-6 shadow-2xl relative animate-in fade-in zoom-in duration-300">

            {/* Close Button */}
            <button
                onClick={() => setOpenModal(false)}
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-slate-100 dark:bg-white/10 hover:bg-slate-200 dark:hover:bg-white/20 transition-colors flex items-center justify-center text-slate-700 dark:text-white"
            >
                ✕
            </button>

            {/* Header */}
            <div className="mb-6">
                <h2 className="text-3xl font-bold text-slate-900 dark:text-white">
                    Book an Appointment
                </h2>

                <p className="text-slate-500 dark:text-slate-400 mt-2">
                    Please fill in your details and we will contact you shortly.
                </p>
            </div>

            {/* Form */}
            <form className="grid md:grid-cols-2 gap-4">

                <input
                    type="text"
                    placeholder="Full Name"
                    className="w-full bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                    type="tel"
                    placeholder="Phone Number"
                    className="w-full bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                    type="email"
                    placeholder="Email Address"
                    className="w-full bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                    type="date"
                    className="w-full bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white rounded-2xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                />

                <textarea
                    placeholder="Describe your issue or treatment needed"
                    rows={5}
                    className="md:col-span-2 w-full bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white rounded-2xl px-4 py-3 outline-none resize-none focus:ring-2 focus:ring-blue-500"
                ></textarea>

                <button
                    type="submit"
                    className="md:col-span-2 bg-gradient-to-r from-blue-600 to-cyan-500 hover:opacity-90 text-white py-4 rounded-2xl font-bold text-lg transition-all duration-300 shadow-lg"
                >
                    Submit Appointment Request
                </button>

            </form>
        </div>
    </div>
)}
                        </div>

                        {/* Footer */}
                        <div className="text-center mt-10 text-sm text-slate-600 dark:text-slate-500">
                            © 2026 Dr. Mohammad Sherzad — All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}